// extracted by mini-css-extract-plugin
module.exports = {"List":"WebsiteTypes_List__1thyD","Label":"WebsiteTypes_Label__1RsEk"};